import { render, staticRenderFns } from "./ResourceCalendarOverview.vue?vue&type=template&id=4d087fdb&scoped=true"
import script from "./ResourceCalendarOverview.vue?vue&type=script&lang=js"
export * from "./ResourceCalendarOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d087fdb",
  null
  
)

export default component.exports